/* ============================================================
   Calques — tiroirs, modales, recherche

   Un calque ouvert doit garder le focus pour lui. Chaque composant
   gérait son ouverture seul : il déplaçait le focus dedans, mais la
   touche Tab repartait vers la page d'en dessous, sur des liens que le
   calque masquait. Et le point de retour était l'élément actif au moment
   de l'ouverture — souvent `body`, quand le bouton déclencheur venait
   d'être désactivé : à la fermeture, le focus repartait en haut de page.

   Ici, tout ce qui n'est pas le calque devient `inert` : plus atteignable
   au clavier, plus lu par un lecteur d'écran, plus cliquable. On marque
   les frères de chaque ancêtre du calque jusqu'à `body`, ce qui laisse
   le calque et sa lignée intacts sans rien savoir de la structure de la
   page. Un calque ouvert depuis un autre libère ce que le premier avait
   rendu inerte sur son chemin, et le lui rend à sa fermeture.

     lfCalque.ouvrir(element, { focus: cible, retour: declencheur })
     lfCalque.fermer(element)
   ============================================================ */
(function () {
  'use strict';

  var pile = [];
  var NON_VISUEL = /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/;
  var FOCALISABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function focalisables(calque) {
    var liste = [];
    var candidats = calque.querySelectorAll(FOCALISABLE);
    for (var i = 0; i < candidats.length; i++) {
      var el = candidats[i];
      if (el.tabIndex < 0 || el.closest('[inert], [hidden]')) continue;
      if (!el.getClientRects().length || getComputedStyle(el).visibility === 'hidden') continue;
      liste.push(el);
    }
    return liste;
  }

  function premierFocalisable(calque) {
    return focalisables(calque)[0] || null;
  }

  /* `inert` suffit a proteger la page, mais depuis le dernier element du
     calque, Tab partait vers la barre d'adresse avant de revenir. On
     reboucle a l'interieur, comme le fait le theme de reference. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !pile.length) return;
    var calque = pile[pile.length - 1].calque;
    var liste = focalisables(calque);
    if (!liste.length) { e.preventDefault(); return; }
    var actif = document.activeElement;
    var dedans = calque.contains(actif);
    if (e.shiftKey && (!dedans || actif === liste[0])) {
      e.preventDefault();
      liste[liste.length - 1].focus();
    } else if (!e.shiftKey && (!dedans || actif === liste[liste.length - 1])) {
      e.preventDefault();
      liste[0].focus();
    }
  });

  /* Un calque qui vient de recevoir sa classe d'ouverture n'est pas
     toujours focalisable dans la même frame — visibilité ou `hidden`
     retirés par une transition. On réessaie sur quelques images. */
  function focaliser(cible, essais) {
    if (!cible) return;
    cible.focus({ preventScroll: true });
    if (document.activeElement !== cible && essais > 0) {
      requestAnimationFrame(function () { focaliser(cible, essais - 1); });
    }
  }

  function ouvrir(calque, options) {
    if (!calque) return;
    options = options || {};
    fermer(calque, { sansRetour: true });

    var actif = document.activeElement;
    var retour = options.retour || (actif && actif !== document.body ? actif : null);

    var liberes = [];
    for (var n = calque; n && n !== document.body; n = n.parentElement) {
      if (n.inert) {
        n.inert = false;
        liberes.push(n);
      }
    }

    var marques = [];
    for (var m = calque; m && m !== document.body && m.parentElement; m = m.parentElement) {
      var freres = m.parentElement.children;
      for (var i = 0; i < freres.length; i++) {
        var f = freres[i];
        if (f === m || f.inert || NON_VISUEL.test(f.tagName)) continue;
        f.inert = true;
        marques.push(f);
      }
    }

    pile.push({ calque: calque, retour: retour, marques: marques, liberes: liberes });

    if (options.focus !== false) {
      var cible = options.focus || premierFocalisable(calque) || calque;
      if (cible === calque && !calque.hasAttribute('tabindex')) calque.setAttribute('tabindex', '-1');
      focaliser(cible, 6);
    }
  }

  function fermer(calque, options) {
    options = options || {};
    var index = -1;
    for (var i = pile.length - 1; i >= 0; i--) {
      if (pile[i].calque === calque) { index = i; break; }
    }
    if (index === -1) return;

    var entree = pile.splice(index, 1)[0];
    entree.marques.forEach(function (el) { el.inert = false; });
    entree.liberes.forEach(function (el) { el.inert = true; });

    if (options.sansRetour) return;
    var retour = entree.retour;
    if (retour && retour.isConnected && !retour.closest('[inert]')) {
      retour.focus({ preventScroll: true });
    }
  }

  function estOuvert(calque) {
    for (var i = 0; i < pile.length; i++) if (pile[i].calque === calque) return true;
    return false;
  }

  // Nombre de calques ouverts : la popup promotionnelle attend qu'il soit nul.
  function nombre() { return pile.length; }

  window.lfCalque = { ouvrir: ouvrir, fermer: fermer, estOuvert: estOuvert, nombre: nombre };
})();
